// test650
(650 && 0);
